/**
 * Next.jsのAPI Routesなど、サーバーサイドでインポートする際に
 * クライアントサイドのHooks(swr等)への依存によるビルドエラーを避けるため、
 * 定数データのみをこのファイルに分離しています。
 */
import { type AppLinkKey } from "./apps-data";

export type DomainRecord = Record<AppLinkKey, string>;

export const developmentDomains: DomainRecord = {
  core: "https://core.dev.m2msystems.cloud",
  sumyca: "https://manage.dev.sumyca.com",
  cleaning: "https://manager-cleaning.dev.m2msystems.cloud",
  users: "https://manage-users.dev.m2msystems.cloud",
  checkin: "https://manage.checkin.dev.m2msystems.cloud",
  checkinV2: "https://manage.checkin-v2.dev.m2msystems.cloud",
  systems: "https://dev.m2msystems.cloud",
  messages: "https://messages.dev.m2msystems.cloud",
  agents: "https://agents.m2msystems.cloud",
  workflows: "https://workflows.dev.m2msystems.cloud",
};

export const productionDomains: DomainRecord = {
  core: "https://core.m2msystems.cloud",
  sumyca: "https://manage.sumyca.com",
  cleaning: "https://manager-cleaning.m2msystems.cloud",
  users: "https://manage-users.m2msystems.cloud",
  checkin: "https://manage.checkin.m2msystems.cloud",
  checkinV2: "https://manage.checkin-v2.m2msystems.cloud",
  systems: "https://m2msystems.cloud/",
  messages: "https://messages.m2msystems.cloud",
  agents: "https://agents.m2msystems.cloud/",
  workflows: "https://workflows.m2msystems.cloud",
};
